/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Demo_Hello_TitleInputs */

const en_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello World`)
};

const ar_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا بالعالم`)
};

const bn_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হ্যালো ওয়ার্ল্ড`)
};

const de_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo Welt`)
};

const es_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola mundo`)
};

const fr_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour tout le monde`)
};

const pt_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá, mundo`)
};

const zh_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你好世界`)
};

const tr_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba Dünya`)
};

const ru_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет, мир`)
};

const pl_draft_demo_hello_title = /** @type {(inputs: Draft_Demo_Hello_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witaj, świecie`)
};

/**
* | output |
* | --- |
* | "Hello World" |
*
* @param {Draft_Demo_Hello_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const draft_demo_hello_title = /** @type {((inputs?: Draft_Demo_Hello_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Demo_Hello_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_draft_demo_hello_title(inputs)
	if (locale === "bn") return bn_draft_demo_hello_title(inputs)
	if (locale === "de") return de_draft_demo_hello_title(inputs)
	if (locale === "es") return es_draft_demo_hello_title(inputs)
	if (locale === "fr") return fr_draft_demo_hello_title(inputs)
	if (locale === "pt") return pt_draft_demo_hello_title(inputs)
	if (locale === "zh") return zh_draft_demo_hello_title(inputs)
	if (locale === "tr") return tr_draft_demo_hello_title(inputs)
	if (locale === "ru") return ru_draft_demo_hello_title(inputs)
	if (locale === "pl") return pl_draft_demo_hello_title(inputs)
	return en_draft_demo_hello_title(inputs)
});